<!--

    # rxeob-table

    This component is partitioned/sectioned table, for use when you want a table broken out into sections.
    It consists of multiple Buefy tables in the backend, but acts as a single table in regards to sorting, row selection, etc.

    ## Props

    - sections: Array of data sections to display; each section will become a Buefy table on the backend. Each object in the array should be
        of the form: { display: "My Section Name", items: [] }
    - columns: Array of column configs to pass into the underlying Buefy tables. See [the Buefy docs](https://buefy.org/documentation/table) for more information.
    - iconPack: The icon pack to use.
    - mobileCards: true use the mobile cards view, false to keep the table view on mobile.

    ## Events

    - click(row): Fired when a row is selected.
    - section-collapse(row): Fired when a section is collapsed.
    - clear-selection: Fired when the row selection is cleared.

    ## Method

    - clearSelection: Clears the row selection.

-->
<template>
  <div class="rxeob-table">
    <b-table :data="[{}]" :mobile-cards="false" icon-pack="fa" :backend-sorting="true" @sort="tableSorter" ref="headers">
      <template slot-scope="props">
        <b-table-column :label="getDefault('column_medication')" field="Ln" width="275" sortable="">
        </b-table-column>
        <b-table-column :label="getDefault('column_copay')" field="Price.MemberCost" width="100" sortable="" numeric="">
        </b-table-column>
        <b-table-column :label="getDefault('column_tier')" field="Tier.Tier" width="200" sortable="">
        </b-table-column>
        <b-table-column :label="getDefault('column_indicator')" field="Indicators" width="175">
        </b-table-column>
        <b-table-column width="50">
        </b-table-column>
      </template>
    </b-table>
    <div v-model="componentKey"></div>
    <div v-show="hasResults('1')">
      <div class="apollo-divider">
        <div>
          <span class="header" @click="collapseSection('1')">
            {{getDefault(tableData["1"].ResultType.StrategyType)}}
            <span class="collapse-toggle-wrapper">
              <i class="fas fa-chevron-up collapse-toggle" :class="{ collapsed: collapsed['1'] }"></i>
            </span>
          </span>
        </div>
      </div>
      <div class="slide-up" :class="{ 'slide-up-to': collapsed['1'] }">
        <b-table :data="tableData['1'].ResultsFiltered"
             @click="resultClick"
             :hoverable="true"
             :mobile-cards="false"
             :row-class="getCssClasses"
             :selected.sync="currentResult">
          <template slot-scope="props">
            <b-table-column label="Medication" width="275">

                  <b-tooltip class="is-hidden-mobile"
                             :label="props.row.BrandGenericEquivalent"
                             size="is-small"
                             multilined>
                      {{props.row.Ln}}
                  </b-tooltip>
                  <span class="is-hidden-tablet">{{props.row.Ln}}</span>
              </b-table-column>
            <b-table-column label="Copay" width="100" numeric="">
              <span>{{(props.row.TierOverridden ? props.row.Price.MemberCostOverride : props.row.Price.MemberCost) | currency}}</span>
            </b-table-column>
            <b-table-column label="Tier" width="200">
                <!--<span v-if="tableData[1].healthplanid == 31">{{ (props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (" Tier " + props.row.Tier.Tier)) }}</span>-->
                <span v-if="tableData[1].healthplanid == 31 || tableData[1].healthplanid == 74 || tableData[1].healthplanid == 76">{{ (props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.TierName)) }}</span>
                <span v-if="tableData[1].healthplanid != 31 && tableData[1].healthplanid != 74 && tableData[1].healthplanid != 76">{{ (props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.Tier + " / " + props.row.Tier.TierName)) }}</span>
            </b-table-column>
            <b-table-column label="Indicators" width="175">
              <span v-for="(i) in props.row.Indicators" class="indicator">
                <b-tooltip v-bind:label="i.IndicatorDescription"
                           class="is-hidden-mobile"
                           size="is-large"
                           multilined>
                  {{i.IndicatorCode}}
                </b-tooltip>
                <span
                           class="is-hidden-tablet"
                           size="is-large"
                           multilined>
                  {{i.IndicatorCode}}
                </span>
              </span>
            </b-table-column>
            <b-table-column width="50">
                <b-tooltip :label="getDefault('more_information')" position="is-left">
                    <b-icon pack="fas"
                            icon="info-circle">
                    </b-icon>
                </b-tooltip>
            </b-table-column>
          </template>
          <template slot-scope="props" slot="header">
          </template>
        </b-table>
      </div>
    </div>
    <div v-model="componentKey"></div>
    <div v-show="hasResults('2')">
      <div class="apollo-divider">
        <div>
          <span class="header" @click="collapseSection('2')">
            {{getDefault(tableData["2"].ResultType.StrategyType)}}
            <span class="collapse-toggle-wrapper">
              <i class="fas fa-chevron-up collapse-toggle" :class="{ collapsed: collapsed['2'] }"></i>
            </span>
          </span>
        </div>
      </div>
      <div class="slide-up" :class="{ 'slide-up-to': collapsed['2'] }">
        <b-table :data="tableData['2'].ResultsFiltered"
             @click="resultClick"
             :hoverable="true"
             :mobile-cards="false"
             :row-class="getCssClasses"
             :selected.sync="currentResult">
          <template slot-scope="props">
            <b-table-column label="Medication" width="275">
                  <b-tooltip class="is-hidden-mobile"
                             :label="props.row.BrandGenericEquivalent"
                             size="is-small"
                             multilined>
                      {{props.row.Ln}}
                  </b-tooltip>
                  <span class="is-hidden-tablet">{{props.row.Ln}}</span>
              </b-table-column>
            <b-table-column label="Copay" width="100" numeric="">
              <span>{{(props.row.TierOverridden ? props.row.Price.MemberCostOverride : props.row.Price.MemberCost) | currency}}</span>
            </b-table-column>
            <b-table-column label="Tier" width="200">
                <span v-if="tableData[1].healthplanid == 31 || tableData[1].healthplanid == 74 || tableData[1].healthplanid == 76">{{ (props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.TierName)) }}</span>
                <span v-if="tableData[1].healthplanid != 31 && tableData[1].healthplanid != 74 && tableData[1].healthplanid != 76">{{ (props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.Tier + " / " + props.row.Tier.TierName)) }}</span>
            </b-table-column>
            <b-table-column label="Indicators" width="175">
              <span v-for="(i) in props.row.Indicators" class="indicator">
                <b-tooltip v-bind:label="i.IndicatorDescription"
                        class="is-hidden-mobile"
                       size="is-large"
                       multilined>
                  {{i.IndicatorCode}}
                  </b-tooltip>
                <span  class="is-hidden-tablet"
                           size="is-large"
                           multilined>
                  {{i.IndicatorCode}}
                </span>
              </span>
            </b-table-column>
            <b-table-column width="50">
                <b-tooltip :label="getDefault('more_information')" position="is-left">
                    <b-icon pack="fas"
                            icon="info-circle">
                    </b-icon>
                </b-tooltip>
            </b-table-column>
          </template>
          <template slot-scope="props" slot="header">
          </template>
        </b-table>
      </div>
    </div>

    <div v-model="componentKey"></div>
    <div v-show="hasResults('3')">
      <div class="apollo-divider">
        <div>
          <span class="header" @click="collapseSection('3')">
            {{getDefault(tableData["3"].ResultType.StrategyType)}}
            <span class="collapse-toggle-wrapper">
              <i class="fas fa-chevron-up collapse-toggle" :class="{ collapsed: collapsed['3'] }"></i>
            </span>
          </span>
        </div>
      </div>
      <div class="slide-up" :class="{ 'slide-up-to': collapsed['3'] }">
        <b-table :data="tableData['3'].ResultsFiltered"
             @click="resultClick"
             :hoverable="true"
             :mobile-cards="false"
             :row-class="getCssClasses"
             :selected.sync="currentResult">
          <template slot-scope="props">
            <b-table-column label="Medication" width="275">
                  <b-tooltip class="is-hidden-mobile"
                             :label="props.row.BrandGenericEquivalent"
                             size="is-small"
                             multilined>
                      {{props.row.Ln}}
                  </b-tooltip>
                  <span class="is-hidden-tablet">{{props.row.Ln}}</span>
              </b-table-column>

            <b-table-column label="Copay" width="100" numeric="">
              <span>{{(props.row.TierOverridden ? props.row.Price.MemberCostOverride : props.row.Price.MemberCost) | currency}}</span>
            </b-table-column>
            <b-table-column label="Tier" width="200">
                <span v-if="tableData[1].healthplanid == 31 || tableData[1].healthplanid == 74 || tableData[1].healthplanid == 76">{{ (props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.TierName)) }}</span>
                <span v-if="tableData[1].healthplanid != 31 && tableData[1].healthplanid != 74 && tableData[1].healthplanid != 76">{{ (props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.Tier + " / " + props.row.Tier.TierName)) }}</span>
            </b-table-column>
            <b-table-column label="Indicators" width="175">
              <span v-for="(i) in props.row.Indicators" class="indicator">
                <b-tooltip v-bind:label="i.IndicatorDescription"
                           class="is-hidden-mobile"
                           size="is-large"
                           multilined>
                  {{i.IndicatorCode}}
                  </b-tooltip>
                <span  class="is-hidden-tablet"
                           size="is-large"
                           multilined>
                  {{i.IndicatorCode}}
                </span>
              </span>
            </b-table-column>
            <b-table-column width="50">
                <b-tooltip :label="getDefault('more_information')" position="is-left">
                    <b-icon pack="fas"
                            icon="info-circle">
                    </b-icon>
                </b-tooltip>
            </b-table-column>
          </template>
          <template slot-scope="props" slot="header">
          </template>
        </b-table>
      </div>
    </div>
    <div v-model="componentKey"></div>
    <div v-show="hasResults('4')">
      <div class="apollo-divider">
        <div>
          <span class="header" @click="collapseSection('4')">
            {{getDefault(tableData["4"].ResultType.StrategyType)}}
            <span class="collapse-toggle-wrapper">
              <i class="fas fa-chevron-up collapse-toggle" :class="{ collapsed: collapsed['4'] }"></i>
            </span>
          </span>
        </div>
      </div>
      <div class="slide-up" :class="{ 'slide-up-to': collapsed['4'] }">
        <b-table :data="tableData['4'].ResultsFiltered"
             @click="resultClick"
             :hoverable="true"
             :mobile-cards="false"
             :row-class="getCssClasses"
             :selected.sync="currentResult">
          <template slot-scope="props">
            <b-table-column label="Medication" width="275">
                 <b-tooltip class="is-hidden-mobile"
                             :label="props.row.BrandGenericEquivalent"
                             size="is-small"
                             multilined>
                      {{props.row.Ln}}
                  </b-tooltip>
                  <span class="is-hidden-tablet">{{props.row.Ln}}</span>
              </b-table-column>
            <b-table-column label="Copay" width="100" numeric="">
              <span>{{(props.row.TierOverridden ? props.row.Price.MemberCostOverride : props.row.Price.MemberCost) | currency}}</span>
            </b-table-column>
            <b-table-column label="Tier" width="200">
                <span v-if="tableData[1].healthplanid == 31 || tableData[1].healthplanid == 74 || tableData[1].healthplanid == 76">{{ (props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.TierName)) }}</span>
                <span v-if="tableData[1].healthplanid != 31 && tableData[1].healthplanid != 74 && tableData[1].healthplanid != 76">{{ (props.row.TierOverridden ? (props.row.Tier.TierOverride + " / " + props.row.Tier.TierNameOverride) : (props.row.Tier.Tier + " / " + props.row.Tier.TierName)) }}</span>
            </b-table-column>
            <b-table-column label="Indicators" width="175">
              <span v-for="(i) in props.row.Indicators" class="indicator">
                <b-tooltip v-bind:label="i.IndicatorDescription"
                           class="is-hidden-mobile"
                           size="is-large"
                           multilined>
                  {{i.IndicatorCode}}
                </b-tooltip>
              <span  class="is-hidden-tablet"
                           size="is-large"
                           multilined>
                  {{i.IndicatorCode}}
                </span>

              </span>
            </b-table-column>
            <b-table-column width="50">
                <b-tooltip :label="getDefault('more_information')" position="is-left">
                    <b-icon pack="fas"
                            icon="info-circle">
                    </b-icon>
                </b-tooltip>
            </b-table-column>
          </template>
          <template slot-scope="props" slot="header">
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import _ from 'lodash';
  import Default from "../models/Default.js";

  export default {
  props: {
  datasource: Object,
  searchoptions: Object,
  defaults: Array
  },
  data: function () {
  return {
  tableData: this.datasource,
  currentResult: null,
  collapsed: {
  '1': false,
  '2': false,
  '3': false,
  '4': false
  },
  componentKey: 0
  };
  },
  methods: {
  tableSorter: function (column, direction) {
  console.log(column, direction);
  var isAsc = (direction == "asc");
      this.applySort(column, isAsc);
  },
  applySort: function (columnName, isAsc) {
  var me = this;
  Object.keys(this.tableData).forEach(function (item) {
  me.tableData[item].ResultsFiltered = me.tableData[item].ResultsFiltered.sort(function (a, b) {
  if (isAsc) {
  return (_.get(a, columnName) > _.get(b, columnName)) ? 1 : -1;
  } else {
  return (_.get(b, columnName) > _.get(a, columnName)) ? 1 : -1;
  }
  });
  });
  },
  updateTableData: function() {
  this.componentKey++;
  //this.tableData = this.datasource;
  },
  hasResults: function (resultGroupId) {
  return (this.tableData[resultGroupId].Results.length > 0);
  },
  resultClick: function (row) {
  this.currentResult = row;
  this.$emit("click", row);
  },
  clearSelection: function () {
  this.currentResult = null;
  this.$emit("clear-selection");
  },
  collapseSection: function (section) {
  this.collapsed[section] = !this.collapsed[section];
  this.$emit("section-collapse", section);
  },
  collapseAll: function (open) {
  var me = this;
  Object.keys(this.collapsed).forEach(function (item) {
  me.collapsed[item] = open;
  });
  },
  clearCurrentResult: function(){
  this.currentResult = null;
  },
  getDefault: function (nameKey) {
  return Default.Find(nameKey, this.defaults);
  },
  /* Returns list of classes to apply to the result row.
  *
  * @return {string} The list of CSS classes to apply.
  */
  getCssClasses: function (row) {
  let classes = "clickable"

  if (row.Ln.trim() == this.searchoptions.ln.trim()) {
  classes += " searched";
  }

  // add a CSS class for each indicator on the result.
  if (row.Indicators) {
  row.Indicators.forEach(function (indicator) {
  let name = " indicator-" + indicator.IndicatorCode.replace(" ", "-").toLowerCase();
  classes += name;
  });
  }

  return classes;
  }
  },
  filters: {
  currency: function (v) {
  if (v == null) {
  return "";
  }
  if (typeof (v) === "string") {
  return v;
  }

  return "$" + v.toFixed(2);
  },
  defaultReplace: function (v, str) {
  return str.replace("{0}", v);
  }
  },
  computed: {
  }
  }
</script>



// WEBPACK FOOTER //
// DrugSearchTable.vue?747d38de